<div>
  <h1>{{'RESULTS.SECTIONS.BASELINE_INCOME_STATEMENT' | anessaTranslation: trigger}}</h1>
  <!--SET AS DEFAULT BUTTON-->
  <div>
    <app-result-set-config-btn *ngIf="resultConf"
                               [resultSetConfig]="resultConf"
                               (toggleChangeNotifier)="onResultSetDefaultChange()"
    >
    </app-result-set-config-btn>
  </div>
  <!--END SET AS DEFAULT BUTTON-->
  <!--START SELECTION BOXES-->
  <div class="row fl">
    <!-- Category Select -->
    <div class="fl-item">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-income-statement-category_select"
          [(value)]="selectedCategory"
          [placeholder]="'RESULTS.GENERAL.SET_CATEGORY' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of categories"
            [value]="opt">{{ opt.translationId | anessaTranslation: trigger}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Currency Select -->
    <div class="fl-item" *ngIf="currencyUnitsLoaded">
      <mat-form-field floatLabel="never" class="anessa-dropdown">
        <mat-select
          id="baseline-income-statement-currency_select"
          [(value)]="selectedCurrency"
          [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
          disableOptionCentering
          (valueChange)="setTableData(); setResultSetConfDisabled()"
          panelClass="anessa-dropdown-panel">
          <mat-option
            *ngFor="let opt of currencyUnits"
            [value]="opt">{{ opt.translationId | anessaTranslation: trigger }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <!--END SELECTION BOXES-->
  <div class="fl" *ngIf="isShowResults()">
    <p>{{'RESULTS.GENERAL.EXCHANGE_RATES_FROM' | anessaTranslation: trigger}} <i>{{ exchangeRateDate }}</i></p>
  </div>

  <results-treetable
    [resultsData]="isplResults"
    [groupAggregationMethod]="aggMethod"
    [hideOnlyZeros]="true"
    [aggregationBlackList]="['RESULTS.DATA.ISPL.EARNINGS']"
    [firstColumnHeader]="'RESULTS.GENERAL.YEARS' | anessaTranslation: trigger"
  ></results-treetable>

</div>
